import _ from 'lodash';
import React from 'react';
import { Field, Form } from 'formik';

// Material UI
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';

// Data
import { IEditPlayer } from './edit-player.interface';
import messages from './edit-player.messages';
import { GENDER_OPTIONS } from '../../../lib/constants';

// Components
import { FormikInput } from '../../_core/Formik/formik-input.component';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { FormHelperText } from '../../_core/_ui/forms.component';
import CircularProgress from '@material-ui/core/CircularProgress';

import { FocusFirstInvalidField } from '../../_core/Formik/focus-first-invalid-field.component';
import { PrimaryButton } from '../../_core/_ui/buttons.component';
import { FormikSelect } from '../../_core/Formik/formik-select.component';
import { Typography } from '@material-ui/core';
import { PrimarySportFormOptions, Sport, SportTerminology } from '../../../lib/types';
import { useCompanySport, useCompanySportTerminology } from '../../../lib/stores/company.store';
import { SharedPlayerProfileFields } from '../SharedPlayerProfileFields/shared-player-profile-fields.component';

const FORM_ID = 'edit-player-form';

const EditPlayer: React.FC<IEditPlayer> = ({
  form,
  submitError,
  showSaved,
  fetchError,
  loading,
  hasConfigRole,
}) => {
  const sport = useCompanySport()
  const termLookup = useCompanySportTerminology();
  const { isSubmitting } = form;
  const genderOptions = _.filter(GENDER_OPTIONS, option => option.value !== 'Any');

  if (fetchError) return <Box mt={2}><Typography>Unable to edit this {termLookup[SportTerminology.ATHLETE]} at this time. Please try again later</Typography></Box>;

  return (
    <Form id={FORM_ID}>
      <FocusFirstInvalidField formId={FORM_ID} />
      <SharedPlayerProfileFields />
      <Field fid="csf" name="gender" component={FormikSelect} label={messages.lblGender} options={genderOptions} />
      <Field fid="cpf" name="externalId" component={FormikInput} label={messages.lblExternalId} />
      {sport === Sport.default &&
        <Field
          fid="cpf"
          name="primarySport"
          component={FormikSelect}
          label={messages.lblPrimarySport}
          options={PrimarySportFormOptions}
        />
      }

      {!!hasConfigRole && <>
        <FormControl margin="dense">
          <Box display="flex" flexDirection="row" alignItems="center">
            <PrimaryButton disabled={isSubmitting} type="submit">
              {isSubmitting && <CircularProgress size={20} style={{ marginRight: 8, color: 'white' }} />}
              {isSubmitting ? <IntlMsg {...messages.btnSubmitting} /> : <IntlMsg {...messages.btnSubmit} />}
            </PrimaryButton>
            {submitError && <Box ml={2}><FormHelperText error>{submitError}</FormHelperText></Box>}
            {showSaved && <Box ml={2}><FormHelperText className="success">Successfully saved</FormHelperText></Box>}
          </Box>
        </FormControl>
      </>}
    </Form>
  );
};

export { EditPlayer };
